/**
 * @generated SignedSource<<862e802d0b3f25190ca021a676f4353d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserAppsRouterQuery$variables = {
  skipMe: boolean;
  skipUser: boolean;
  userId: string;
};
export type UserAppsRouterQuery$data = {
  readonly viewer: {
    readonly me?: {
      readonly hasDedicatedApp: boolean;
      readonly id: string;
    } | null | undefined;
    readonly user?: {
      readonly hasDedicatedApp: boolean;
      readonly id: string;
    } | null | undefined;
  };
};
export type UserAppsRouterQuery = {
  response: UserAppsRouterQuery$data;
  variables: UserAppsRouterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipMe"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipUser"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasDedicatedApp",
    "storageKey": null
  }
],
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Viewer",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "condition": "skipMe",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": (v3/*:: as any*/),
            "storageKey": null
          }
        ]
      },
      {
        "condition": "skipUser",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "userId"
              }
            ],
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v3/*:: as any*/),
            "storageKey": null
          }
        ]
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserAppsRouterQuery",
    "selections": (v4/*:: as any*/),
    "type": "QueryRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "UserAppsRouterQuery",
    "selections": (v4/*:: as any*/)
  },
  "params": {
    "cacheID": "7f0f37e189f3466b41476466c000e912",
    "id": null,
    "metadata": {},
    "name": "UserAppsRouterQuery",
    "operationKind": "query",
    "text": "query UserAppsRouterQuery(\n  $userId: ID!\n  $skipMe: Boolean!\n  $skipUser: Boolean!\n) {\n  viewer {\n    me @skip(if: $skipMe) {\n      id\n      hasDedicatedApp\n    }\n    user(id: $userId) @skip(if: $skipUser) {\n      id\n      hasDedicatedApp\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c4ec65db1429a2d707ee840ad2e08194";

export default node;
